// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.parent {
  height: 100%;
}

.item-selectable-article {
  height: 100%;
  position: relative;
  margin: 0 auto;
  padding: 8%;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  border: 1px solid #000000;
  border-radius: 8px;
  transition: background 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}
@media (min-width: 991px) {
  .item-selectable-article {
    cursor: pointer;
  }
  .item-selectable-article:hover {
    border: 1px solid var(--color-black);
  }
}
.item-selectable-article.selected {
  border: 2px solid var(--ion-color-primary);
}
.item-selectable-article .wrapper-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item-selectable-article .footer-block {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 10px 2px 5px;
}
.item-selectable-article .footer-block .width-item {
  width: 20px;
}
.item-selectable-article .footer-block .option-item {
  font-size: 12px;
  height: 16px;
  font-family: AppFont;
}
.item-selectable-article .footer-block .option-price {
  height: -moz-fit-content;
  height: fit-content;
  font-family: Title;
  font-size: 24px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  white-space: nowrap;
}
.item-selectable-article .footer-block .option-price.no-price {
  min-height: 12px;
  max-height: 12px;
}
.item-selectable-article .footer-block .added-item {
  display: flex;
  justify-content: flex-end;
}
.item-selectable-article .footer-block .added-item .selected-circle {
  border: 1px solid var(--color-black);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f6f1ef;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon {
  visibility: none;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
}
.item-selectable-article .footer-block .added-item .selected-circle ion-icon.selected {
  visibility: visible;
  opacity: 1;
}

.selected-block {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected-block .info {
  height: 20px;
  width: 20px;
}
.selected-block .added-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
}
.selected-block .added-item .selected-text {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: lowercase;
  margin-right: 5px;
}
.selected-block .added-item .selected-circle {
  height: 24px;
  width: 24px;
  border: 1px solid #000000;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-block .added-item .selected-circle ion-icon {
  width: 100%;
  height: 100%;
  scale: 0;
  transition: scale 0.3s ease-in-out;
}
.selected-block .added-item .selected-circle ion-icon.selected {
  scale: 1.15;
}

.name {
  min-height: 33px;
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.item-selectable-article-image {
  margin: 0 auto;
  height: 70px;
  max-width: 80px;
  object-fit: contain;
}
.item-selectable-article-image.default-img {
  width: 150px;
  object-fit: contain;
  --icon-color: black;
}

.wrapp {
  margin-top: 10px;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  width: -moz-fit-content;
  width: fit-content;
  background: transparent;
  margin: auto;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  width: 30px;
  font-family: AppFontBold;
  font-size: 15px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
}
.quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,YAAA;AADD;;AAIA;EACC,YAAA;AADD;;AAIA;EACC,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AADD;ACzBE;EDUF;IAmBE,eAAA;EAAA;EACA;IAEC,oCAAA;EAAD;AACF;AAEC;EACC,0CAAA;AAAF;AAEC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEC;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AAAF;AACE;EACC,WAAA;AACH;AACE;EACC,eAAA;EACA,YAAA;EACA,oBAAA;AACH;AACE;EACC,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,mBAAA;AAAH;AACG;EACC,gBAAA;EACA,gBAAA;AACJ;AAEE;EACC,aAAA;EACA,yBAAA;AAAH;AACG;EACC,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAAI;EACC,gBAAA;EACA,UAAA;EACA,qCAAA;AAEL;AADK;EACC,mBAAA;EACA,UAAA;AAGN;;AAKA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFD;AAIC;EACC,YAAA;EACA,WAAA;AAFF;AAKC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAHF;AAKE;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;AAHH;AAME;EACC,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJH;AAMG;EACC,WAAA;EACA,YAAA;EACA,QAAA;EACA,kCAAA;AAJJ;AAKI;EACC,WAAA;AAHL;;AAUA;EACC,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAPD;;AAUA;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAPD;AAQC;EACC,YAAA;EACA,mBAAA;EACA,mBAAA;AANF;;AAaA;EACC,gBAAA;AAVD;;AAYA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,uBAAA;EAEA,YAAA;EAKA,YAAA;AAdD;AAUC;EACC,eAAA;EACA,eAAA;AARF;AAWC;EACC,WAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AATF;AAWC;EACC,WAAA;EACA,YAAA;AATF;AAUE;EACC,YAAA;AARH","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.parent {\n\theight: 100%;\n}\n\n.item-selectable-article {\n\theight: 100%;\n\tposition: relative;\n\tmargin: 0 auto;\n\tpadding: 8%;\n\tflex-grow: 1;\n\tmin-height: 100%;\n\tword-break: break-word;\n\tborder: 1px solid #000000;\n\tborder-radius: 8px;\n\ttransition: background 200ms linear;\n\ttext-align: center;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbackground: #fff;\n\n\t@include desktop {\n\t\tcursor: pointer;\n\t\t&:hover {\n\t\t\t// background: #EBDFDA;\n\t\t\tborder: 1px solid var(--color-black);\n\t\t}\n\t}\n\t&.selected {\n\t\tborder: 2px solid var(--ion-color-primary);\n\t}\n\t.wrapper-item {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\t.footer-block {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 10px 2px 5px;\n\t\t.width-item {\n\t\t\twidth: 20px;\n\t\t}\n\t\t.option-item {\n\t\t\tfont-size: 12px;\n\t\t\theight: 16px;\n\t\t\tfont-family: AppFont;\n\t\t}\n\t\t.option-price {\n\t\t\theight: fit-content;\n\t\t\tfont-family: Title;\n\t\t\tfont-size: 24px;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\twhite-space: nowrap;\n\t\t\t&.no-price {\n\t\t\t\tmin-height: 12px;\n\t\t\t\tmax-height: 12px;\n\t\t\t}\n\t\t}\n\t\t.added-item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\t.selected-circle {\n\t\t\t\tborder: 1px solid var(--color-black);\n\t\t\t\tborder-radius: 50%;\n\t\t\t\twidth: 25px;\n\t\t\t\theight: 25px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tbackground: #f6f1ef;\n\t\t\t\tion-icon {\n\t\t\t\t\tvisibility: none;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\ttransition: opacity 500ms ease-in-out;\n\t\t\t\t\t&.selected {\n\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.selected-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.info {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n\n\t.added-item {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin-left: auto;\n\n\t\t.selected-text {\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 10px;\n\t\t\tline-height: 85%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: lowercase;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t.selected-circle {\n\t\t\theight: 24px;\n\t\t\twidth: 24px;\n\t\t\tborder: 1px solid #000000;\n\t\t\tborder-radius: 50px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\tion-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tscale: 0;\n\t\t\t\ttransition: scale 0.3s ease-in-out;\n\t\t\t\t&.selected {\n\t\t\t\t\tscale: 1.15;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.name {\n\tmin-height: 33px;\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tmargin-top: 14px;\n\tmargin-bottom: 0px;\n}\n\n.item-selectable-article-image {\n\tmargin: 0 auto;\n\theight: 70px;\n\tmax-width: 80px;\n\tobject-fit: contain;\n\t&.default-img {\n\t\twidth: 150px;\n\t\tobject-fit: contain;\n\t\t--icon-color: black;\n\t}\n}\n\n// app-quantity-selector {\n//   filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n// }\n.wrapp {\n\tmargin-top: 10px;\n}\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid var(--color-black);\n\tborder-radius: 26px;\n\twidth: fit-content;\n\tbackground: transparent;\n\n\tmargin: auto;\n\tion-icon {\n\t\tmargin: 0px 6px;\n\t\tcursor: pointer;\n\t}\n\tz-index: 999;\n\t.quantity {\n\t\twidth: 30px;\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 15px;\n\t\tline-height: 85%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t}\n\t.quantity-btn {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
